import Layout from "@/shared/layout";
import { ReactNode } from "react";
import { Logo } from "@/modules/common/widgets/logo";
import { LanguageChanger } from "@/modules/user-settings/widgets/language-changer/language-changer";

const { Header, Content } = Layout;

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <Layout className="!min-h-screen">
      <Header className="flex items-center">
        <div className={"container"}>
          <div className={"flex justify-between items-center"}>
            <Logo />

            <div className={"w-20"}>
              <LanguageChanger />
            </div>
          </div>
        </div>
      </Header>
      <Content className="container p-6">{children}</Content>
    </Layout>
  );
}
